import { Playground } from 'docz';
import Frame from "../../../../../src/components/Frame.tsx";
import Treemap from "../../../../../src/components/Treemap";
import shakespeare from '@vx/mock-data/lib/mocks/shakespeare';
import * as React from 'react';
export default {
  Playground,
  Frame,
  Treemap,
  shakespeare,
  React
};